import api from '@api'

function getUserFromStorage (key) {
  const value = localStorage.getItem(key)
  try {
    return JSON.parse(value)
  } catch (e) {
    let user = {}
    api.auth.authUser().then(result => {
      user = { ...result }
      location.reload()
    })
    return user
  }
}

const state = {
  snotify: {
    bodyMaxLength: 180,
    titleMaxLength: 25,
    backdrop: -1,
    position: 'rightTop',
    timeout: 4000,
    showProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    newOnTop: true,
    maxAtPosition: 6,
    maxOnScreen: 8,
    oneAtTime: false,
    preventDuplicates: false
  },
  notEstimatedIssues: [],
  notBudgetIssues: [],
  roles: [],
  priorities: [
    {
      id: 5,
      name: 'Lowest'
    },
    {
      id: 4,
      name: 'Low'
    },
    {
      id: 3,
      name: 'Medium'
    },
    {
      id: 2,
      name: 'High'
    },
    {
      id: 1,
      name: 'Highest'
    }
  ],
  dateFormat: 'MM/dd/yyyy',
  user: getUserFromStorage('user') || {},
  allUsers: [],
  accessToken: localStorage.getItem('access_token') || null,
  permission: localStorage.getItem('permission') || '[]',
  allPermission: [],
  currentUserRole: localStorage.getItem('user_roles') || '',
  currentUserName: localStorage.getItem('user_name') || '',
  currentUserId: localStorage.getItem('user_id') || '',
  isActive: false,
  projectStatuses: ['predevelopment', 'development', 'done'],
  expensesStatuses: [],
  expensesCategories: [],
  currencies: [],
  bankCards: [],
  ownBankDetails: [],
  issueTypes: [],
  issueStatuses: [],
  isJiraAuth: false,
  showSidebar: localStorage.getItem('show_sidebar') ? JSON.parse(localStorage.getItem('show_sidebar')) : true
}

export default state
